
import { AxiosError } from "axios";
import { isBaseError, toBaseError } from "../../../../common/utils/base_error";
import { axiosInstance } from "../../../../common/utils/axios_instance";
import { handleAxiosResponse } from "../../../../common/utils/axios_response";
import { GetAllEmpreendimentoListaRequest, GetAllEmpreendimentoListaResponse } from "../daos/read/get_all_empreendimento_lista";
import { createEmpreendimentoRequest, createEmpreendimentoResponse } from "../daos/create/create_empreendimento";
import { EmpreendimentoBlocoTableRequest, EmpreendimentoBlocoTableResponse } from "../daos/read/get_empreendimento_bloco_table";
import { EmpreendimentoBlocoDropDownDao, EmpreendimentoBlocoDropDownResponse } from "../daos/read/get_empreendimento_bloco_drop_down";
import { UpdateEmpreendimentoRequest } from "../daos/update/update_empreendimento";
import { GetEmpreendimentoRequest, GetEmpreendimentoResponse } from "../daos/read/get_empreendimento";
import { UpdateBlocosRequest, UpdateBlocosResponse } from '../daos/update/update_blocos';
import { DeleteBlocoRequest, DeleteBlocoResponse } from '../daos/delete/delete_bloco';
import { DeleteUnidadeRequest, DeleteUnidadeResponse } from '../daos/delete/delete_unidade';
import { DeleteEmpreendimentoRequest, DeleteEmpreendimentoResponse } from '../daos/delete/delete_empreendimento';
import { CopiaBlocosRequest, CopiaBlocosResponse } from '../daos/create/copia_blocos';
import { CreateUnidadesBlocoRequest, CreateUnidadesBlocoResponse } from '../daos/create/create_unidades_bloco';
import { IIncorporacaoService } from "./incorporacao_service";
import { UpdateUnidadesRequest, UpdateUnidadesResponse } from "../daos/update/update_unidades";
import { CreateItensServicoEmpreendimentoRequest, CreateItensServicoEmpreendimentoResponse } from "../daos/create/create_itens_servico_empreendimento";
import { UpdateItensServicoEmpreendimentoRequest, UpdateItensServicoEmpreendimentoResponse } from "../daos/update/update_itens_servico_empreendimento";
import { GetAllItensServicoEmpreendimentoRequest, GetAllItensServicoEmpreendimentoResponse } from "../daos/read/get_all_itens_servico_empreendimento";
import { GetIncorporacaoImovelByIdRequest, GetIncorporacaoImovelByIdResponse } from "../daos/read/get_incorporacao_imovel_by_id";
import { DeleteItensServicoEmpreendimentoRequest, DeleteItensServicoEmpreendimentoResponse } from "../daos/delete/delete_itens_servico_empreendimento";
import { GetIncorporacaoImovelDropDownRequest, GetIncorporacaoImovelDropDownResponse } from "../daos/read/get_incorporacao_imovel_drop_down";
import { UpdateItensServicoEmpreendimentoByConsultaRequest, UpdateItensServicoEmpreendimentoByConsultaResponse } from "../daos/update/update_itens_servico_empreendimento_by_consulta";
import { GetAllChecklistServicoEmpreendimentoRequest, GetAllChecklistServicoEmpreendimentoResponse } from "../daos/read/get_all_checklist_servico_empreendimento";


/**
 * IncorporacaoService
 */
export class IncorporacaoService implements IIncorporacaoService {

    //#region  Empreendimento

    async getAllEmprendimentoLista(request: GetAllEmpreendimentoListaRequest): Promise<GetAllEmpreendimentoListaResponse> {
        try {
            const result = await axiosInstance({}).post(`/incorporacao/empreendimento/lista`, request);
            const response = handleAxiosResponse<GetAllEmpreendimentoListaResponse>(result);
            return { ...response };
        } catch (error: unknown) {
            if (typeof error === "string") {
                throw new Error(error);
            } else if (isBaseError(error)) {
                throw toBaseError(error);
            } else if (error instanceof AxiosError) {
                throw new Error(error.message);
            } else if (error instanceof Error) {
                throw error;
            } else {
                throw new Error("Falha ao executar requisição!");
            }
        }
    };

    async createEmpreendimento(request: createEmpreendimentoRequest): Promise<createEmpreendimentoResponse> {
        try {
            const result = await axiosInstance({}).post(`/incorporacao/empreendimento/create`, request);
            const response = handleAxiosResponse(result);
            return response;
        } catch (error: unknown) {
            if (typeof error === "string") {
                throw new Error(error);
            } else if (isBaseError(error)) {
                throw toBaseError(error);
            } else if (error instanceof AxiosError) {
                throw new Error(error.message);
            } else if (error instanceof Error) {
                throw error;
            } else {
                throw new Error("Falha ao executar requisição!");
            }
        }
    };


    async getEmpreendimentoBlocoTable(request: EmpreendimentoBlocoTableRequest): Promise<EmpreendimentoBlocoTableResponse[]> {
        try {
            const result = await axiosInstance({}).post(`/incorporacao/empreendimento/blocotable`, request.idBlocos);
            const response = handleAxiosResponse<EmpreendimentoBlocoTableResponse[]>(result);
            return response;
        } catch (error: unknown) {
            if (typeof error === "string") {
                throw new Error(error);
            } else if (isBaseError(error)) {
                throw toBaseError(error);
            } else if (error instanceof AxiosError) {
                throw new Error(error.message);
            } else if (error instanceof Error) {
                throw error;
            } else {
                throw new Error("Falha ao executar requisição!");
            }
        }
    };

    async getEmpreendimentoBlocoDropDown(idEmpreendimento: number): Promise<EmpreendimentoBlocoDropDownResponse> {
        try {
            const result = await axiosInstance({}).get(`/incorporacao/empreendimento/blocodropdown/${idEmpreendimento}`,);
            const response = handleAxiosResponse<EmpreendimentoBlocoDropDownDao[]>(result);
            return { item: [...response] };
        } catch (error: unknown) {
            if (typeof error === "string") {
                throw new Error(error);
            } else if (isBaseError(error)) {
                throw toBaseError(error);
            } else if (error instanceof AxiosError) {
                throw new Error(error.message);
            } else if (error instanceof Error) {
                throw error;
            } else {
                throw new Error("Falha ao executar requisição!");
            }
        }
    };

    async updateEmpreendimento(request: UpdateEmpreendimentoRequest): Promise<UpdateEmpreendimentoRequest> {
        try {
            const result = await axiosInstance({}).post(`/incorporacao/empreendimento/update`, request);
            const response = handleAxiosResponse<UpdateEmpreendimentoRequest>(result);
            return response;
        } catch (error: unknown) {
            if (typeof error === "string") {
                throw new Error(error);
            } else if (isBaseError(error)) {
                throw toBaseError(error);
            } else if (error instanceof AxiosError) {
                throw new Error(error.message);
            } else if (error instanceof Error) {
                throw error;
            } else {
                throw new Error("Falha ao executar requisição!");
            }
        }
    };


    async getEmpreendimentoById(request: GetEmpreendimentoRequest): Promise<GetEmpreendimentoResponse> {
        try {
            const result = await axiosInstance({}).get(`/incorporacao/empreendimento/${request.idEmpreendimento}`);
            const response = handleAxiosResponse<GetEmpreendimentoResponse>(result);
            return response;
        } catch (error: unknown) {
            if (typeof error === "string") {
                throw new Error(error);
            } else if (isBaseError(error)) {
                throw toBaseError(error);
            } else if (error instanceof AxiosError) {
                throw new Error(error.message);
            } else if (error instanceof Error) {
                throw error;
            } else {
                throw new Error("Falha ao executar requisição!");
            }
        }
    };

    async updateBlocos(request: UpdateBlocosRequest): Promise<UpdateBlocosResponse> {

        try {
            const result = await axiosInstance({}).post(`/incorporacao/empreendimento/update-blocos`, request.list);
            const response = handleAxiosResponse<UpdateBlocosResponse>(result);
            return response;
        } catch (error: unknown) {
            if (typeof error === "string") {
                throw new Error(error);
            } else if (isBaseError(error)) {
                throw toBaseError(error);
            } else if (error instanceof AxiosError) {
                throw new Error(error.message);
            } else if (error instanceof Error) {
                throw error;
            } else {
                throw new Error("Falha ao executar requisição!");
            }
        }
    };

    async updateUnidades(request: UpdateUnidadesRequest): Promise<UpdateUnidadesResponse> {

        try {
            const result = await axiosInstance({}).post(`/incorporacao/empreendimento/update-unidades`, request.list);
            const response = handleAxiosResponse<UpdateUnidadesResponse>(result);
            return response;
        } catch (error: unknown) {
            if (typeof error === "string") {
                throw new Error(error);
            } else if (isBaseError(error)) {
                throw toBaseError(error);
            } else if (error instanceof AxiosError) {
                throw new Error(error.message);
            } else if (error instanceof Error) {
                throw error;
            } else {
                throw new Error("Falha ao executar requisição!");
            }
        }
    };

    async deleteBloco(request: DeleteBlocoRequest): Promise<DeleteBlocoResponse> {

        try {
            const result = await axiosInstance({}).get(`/incorporacao/empreendimento/bloco/delete/${request.idBloco}`);
            const response = handleAxiosResponse<DeleteBlocoResponse>(result);
            return response;
        } catch (error: unknown) {
            if (typeof error === "string") {
                throw new Error(error);
            } else if (isBaseError(error)) {
                throw toBaseError(error);
            } else if (error instanceof AxiosError) {
                throw new Error(error.message);
            } else if (error instanceof Error) {
                throw error;
            } else {
                throw new Error("Falha ao executar requisição!");
            }
        }
    };

    async deleteUnidade(request: DeleteUnidadeRequest): Promise<DeleteUnidadeResponse> {

        try {
            const result = await axiosInstance({}).get(`/incorporacao/empreendimento/unidade/delete/${request.idUnidade}`);
            const response = handleAxiosResponse<DeleteUnidadeResponse>(result);
            return response;
        } catch (error: unknown) {
            if (typeof error === "string") {
                throw new Error(error);
            } else if (isBaseError(error)) {
                throw toBaseError(error);
            } else if (error instanceof AxiosError) {
                throw new Error(error.message);
            } else if (error instanceof Error) {
                throw error;
            } else {
                throw new Error("Falha ao executar requisição!");
            }
        }
    };

    async deleteEmpreendimento(request: DeleteEmpreendimentoRequest): Promise<DeleteEmpreendimentoResponse> {

        try {
            const result = await axiosInstance({}).get(`/incorporacao/empreendimento/delete/${request.idEmpreendimento}`);
            const response = handleAxiosResponse<DeleteEmpreendimentoResponse>(result);
            return response;
        } catch (error: unknown) {
            if (typeof error === "string") {
                throw new Error(error);
            } else if (isBaseError(error)) {
                throw toBaseError(error);
            } else if (error instanceof AxiosError) {
                throw new Error(error.message);
            } else if (error instanceof Error) {
                throw error;
            } else {
                throw new Error("Falha ao executar requisição!");
            }
        }
    };


    async copiaBlocos(request: CopiaBlocosRequest): Promise<CopiaBlocosResponse> {
        try {
            const result = await axiosInstance({}).post(`/incorporacao/empreendimento/blocos/copia`, request);
            const response = handleAxiosResponse(result);
            return response;
        } catch (error: unknown) {
            if (typeof error === "string") {
                throw new Error(error);
            } else if (isBaseError(error)) {
                throw toBaseError(error);
            } else if (error instanceof AxiosError) {
                throw new Error(error.message);
            } else if (error instanceof Error) {
                throw error;
            } else {
                throw new Error("Falha ao executar requisição!");
            }
        }
    };

    async createUnidadesBloco(request: CreateUnidadesBlocoRequest): Promise<CreateUnidadesBlocoResponse> {
        try {
            const result = await axiosInstance({}).post(`/incorporacao/empreendimento/blocos/unidades`, request);
            const response = handleAxiosResponse(result);
            return response;
        } catch (error: unknown) {
            if (typeof error === "string") {
                throw new Error(error);
            } else if (isBaseError(error)) {
                throw toBaseError(error);
            } else if (error instanceof AxiosError) {
                throw new Error(error.message);
            } else if (error instanceof Error) {
                throw error;
            } else {
                throw new Error("Falha ao executar requisição!");
            }
        }
    };




    //#endregion

    //#region ITEM SERVICO EMPREENDIMENTO
    async getAllItensServicoEmpreendimento(request: GetAllItensServicoEmpreendimentoRequest): Promise<GetAllItensServicoEmpreendimentoResponse> {
        try {
            const result = await axiosInstance({}).post(`/incorporacao/item-servico-empreendimento/get-all`, request);
            const response = handleAxiosResponse<GetAllItensServicoEmpreendimentoResponse>(result);
            return response;
        } catch (error: unknown) {
            if (typeof error === "string") {
                throw new Error(error);
            } else if (isBaseError(error)) {
                throw toBaseError(error);
            } else if (error instanceof AxiosError) {
                throw new Error(error.message);
            } else if (error instanceof Error) {
                throw error;
            } else {
                throw new Error("Falha ao executar requisição!");
            }
        }
    }

    async getAllChecklistServicoEmpreendimento(request: GetAllChecklistServicoEmpreendimentoRequest): Promise<GetAllChecklistServicoEmpreendimentoResponse> {
        try {
            const result = await axiosInstance({}).post(`/incorporacao/item-servico-empreendimento/get-all-checklist`, request);
            const response = handleAxiosResponse<GetAllChecklistServicoEmpreendimentoResponse>(result);
            return response;
        } catch (error: unknown) {
            if (typeof error === "string") {
                throw new Error(error);
            } else if (isBaseError(error)) {
                throw toBaseError(error);
            } else if (error instanceof AxiosError) {
                throw new Error(error.message);
            } else if (error instanceof Error) {
                throw error;
            } else {
                throw new Error("Falha ao executar requisição!");
            }
        }
    }

    async createItensServicoEmpreendimento(request: CreateItensServicoEmpreendimentoRequest): Promise<CreateItensServicoEmpreendimentoResponse> {
        try {
            const result = await axiosInstance({}).post(`/incorporacao/item-servico-empreendimento/create`, request);
            const response = handleAxiosResponse<CreateItensServicoEmpreendimentoResponse>(result);
            return response;
        } catch (error: unknown) {
            if (typeof error === "string") {
                throw new Error(error);
            } else if (isBaseError(error)) {
                throw toBaseError(error);
            } else if (error instanceof AxiosError) {
                throw new Error(error.message);
            } else if (error instanceof Error) {
                throw error;
            } else {
                throw new Error("Falha ao executar requisição!");
            }
        }
    }

    async updateItensServicoEmpreendimento(request: UpdateItensServicoEmpreendimentoRequest): Promise<UpdateItensServicoEmpreendimentoResponse> {
        try {
            const result = await axiosInstance({}).post(`/incorporacao/item-servico-empreendimento/update`, request);
            const response = handleAxiosResponse<UpdateItensServicoEmpreendimentoResponse>(result);
            return response;
        } catch (error: unknown) {
            if (typeof error === "string") {
                throw new Error(error);
            } else if (isBaseError(error)) {
                throw toBaseError(error);
            } else if (error instanceof AxiosError) {
                throw new Error(error.message);
            } else if (error instanceof Error) {
                throw error;
            } else {
                throw new Error("Falha ao executar requisição!");
            }
        }
    }


    async getIncorporacaoImovelById(request: GetIncorporacaoImovelByIdRequest): Promise<GetIncorporacaoImovelByIdResponse> {
        try {
            const result = await axiosInstance({}).get(`/incorporacao/imovel/${request.idIncorporacaoImovel}`,);
            const response = handleAxiosResponse<GetIncorporacaoImovelByIdResponse>(result);
            return response;
        } catch (error: unknown) {
            if (typeof error === "string") {
                throw new Error(error);
            } else if (isBaseError(error)) {
                throw toBaseError(error);
            } else if (error instanceof AxiosError) {
                throw new Error(error.message);
            } else if (error instanceof Error) {
                throw error;
            } else {
                throw new Error("Falha ao executar requisição!");
            }
        }
    }


    async deleteItensServicoEmpreendimento(request: DeleteItensServicoEmpreendimentoRequest): Promise<DeleteItensServicoEmpreendimentoResponse> {
        try {
            const result = await axiosInstance({}).post(`/incorporacao/item-servico-empreendimento/delete`, request);
            const response = handleAxiosResponse<DeleteItensServicoEmpreendimentoResponse>(result);
            return response;
        } catch (error: unknown) {
            if (typeof error === "string") {
                throw new Error(error);
            } else if (isBaseError(error)) {
                throw toBaseError(error);
            } else if (error instanceof AxiosError) {
                throw new Error(error.message);
            } else if (error instanceof Error) {
                throw error;
            } else {
                throw new Error("Falha ao executar requisição!");
            }
        }
    }

    async getIncorporacaoImovelDropDown(
        request: GetIncorporacaoImovelDropDownRequest
    ): Promise<GetIncorporacaoImovelDropDownResponse> {
        try {
            const result = await axiosInstance({}).post(`/incorporacao/imovel/dropdown`, request);
            const response = handleAxiosResponse<GetIncorporacaoImovelDropDownResponse>(result);
            return response;
        } catch (error: unknown) {
            if (typeof error === "string") {
                throw new Error(error);
            } else if (isBaseError(error)) {
                throw toBaseError(error);
            } else if (error instanceof AxiosError) {
                throw new Error(error.message);
            } else if (error instanceof Error) {
                throw error;
            } else {
                throw new Error("Falha ao executar requisição!");
            }
        }
    }

    async updateItensServicoEmpreendimentoByConsulta(request: UpdateItensServicoEmpreendimentoByConsultaRequest): Promise<UpdateItensServicoEmpreendimentoByConsultaResponse> {
        try {
            const result = await axiosInstance({}).post(`/incorporacao/item-servico-empreendimento/update-by-consulta`, request);
            const response = handleAxiosResponse<UpdateItensServicoEmpreendimentoByConsultaResponse>(result);
            return response;
        } catch (error: unknown) {
            if (typeof error === "string") {
                throw new Error(error);
            } else if (isBaseError(error)) {
                throw toBaseError(error);
            } else if (error instanceof AxiosError) {
                throw new Error(error.message);
            } else if (error instanceof Error) {
                throw error;
            } else {
                throw new Error("Falha ao executar requisição!");
            }
        }
    }

    //#endregion

}

